<template>
  <div>
    <div
      id="special"
      class="order-actions-box"
      v-if="order.status === 'waiting'"
    >
      <QueueButton @click="emitCancel" class="action-cancel-button">
        <img src="/icons/del.svg" class="del" />
      </QueueButton>
      <QueueButton @click="emitAccept" class="w-100" variant="accept">
        {{ $t("actions.accept") }}
      </QueueButton>
    </div>

    <!-- <QueueButton class="action-serve" @click="emitServe" variant="serve">Подано</QueueButton> -->

    <div class="actions-status-serving" v-if="order.status === 'serving'">
      <h5 @click="toggleOptions()" class="modif">
        {{ $t("actions.options") }}
        <img
          :class="!showOptions ? 'arrow1' : 'arrow2'"
          src="/icons/arrow-black.svg"
        />
      </h5>

      <div v-if="showOptions">
        <QueueButton class="action-edit" @click="emitEdit" variant="edit">
          {{ $t("actions.edit") }}
        </QueueButton>
        <QueueButton
          class="action-edit"
          variant="edit"
          @click="emitChangeTable"
          >{{ $t("actions.move") }}</QueueButton
        >
      </div>
    </div>

    <div class="actions-status-serving pt-20" v-if="order.status == 'serving'">
      <QueueButton class="action-pay w-100" @click="emitPay" variant="accept">
        {{ $t("actions.pay") }}
      </QueueButton>

      <div class="order-actions-box m-0 pt-20" v-if="!order.served_at">
        <QueueButton @click="emitCancel" class="action-cancel-button">
          <img src="/icons/del.svg" class="del" />
        </QueueButton>

        <QueueButton class="w-100" @click="emitServe" variant="serve">{{
          $t(cafe.self_service ? "actions.self_serve" : "actions.serve")
        }}</QueueButton>
      </div>
    </div>

    <!-- <QueueButton class="action-pay" @click="emitPay" variant="accept">{{ $t('actions.pay') }}</QueueButton> -->

    <div class="actions-status-served" v-if="order.status === 'served'">
      <QueueButton class="action-pay" @click="emitPay" variant="accept"
        >Розрахувати</QueueButton
      >
      <QueueButton class="action-edit" @click="emitEdit" variant="edit"
        >Редагувати замовлення</QueueButton
      >
      <!-- <p class="pt-3 pb-3 text-center">Пересадити за інший стіл</p> -->
    </div>

    <div
      class="actions-status-paying"
      v-if="order.status === 'paying' && order.pay_method !== 'online'"
      v-show="!hidePayment"
    >
      <div class="discount">
        <b>{{ $t("pay.set_discount") }}</b>

        <div class="form-group mb-0">
          <!-- <select class="form-control discount-combobox" v-model="pay.discount">
            <option v-for="d in discounts" :value="d">{{ d }}%</option>
          </select>-->
          <CenteredSelect
            class="form-control discount-combobox"
            v-model="pay.discount"
            :suffix="'%'"
            :options="discounts"
          />
        </div>
      </div>

      <PaymentMethods v-model="pay.pay_method"/>

      <div class="overall">
        <h4 class="mb-0">{{ $t("card.to_pay") }}</h4>
        <span class="amount">
          {{ OrderHelpers.computeOrderTotal(order) }}{{ currency.symbol }}
        </span>
      </div>

      <!-- <QueueButton class="btn-options mt-4" @click="showOptions = true" v-if="!showOptions">
        <font-awesome-icon icon="bars" class="option-icon" />
        {{$t('actions.options')}}
      </QueueButton>-->

      <div class="actions-cheque">
        <QueueButton
          class="action-merge w-40"
          @click="emitMerge"
          variant="edit"
          >{{ $t("actions.merge") }}</QueueButton
        >
        <QueueButton
          class="action-split w-40"
          @click="emitSplit"
          variant="edit"
          >{{ $t("actions.split") }}</QueueButton
        >
      </div>

      <div id="special" class="order-actions-box">
        <QueueButton class="action-cancel-button" @click="emitReturn">
          <img src="/icons/del.svg" class="del" />
        </QueueButton>

        <QueueButton
          class="w-100 action-confirmPay"
          @click="emitConfirmPay"
          variant="dark"
          >{{ $t("actions.close") }}</QueueButton
        >
      </div>
    </div>

    <div
      class="actions-status-liqpay"
      v-if="order.status === 'paying' && order.pay_method === 'online'"
      v-show="hidePayment"
    >
      <font-awesome-icon icon="lock" />
      <br />
      {{ $t("actions.unlock_desc1") }}
      <br />
      {{ $t("actions.unlock_desc2") }}
      <br />
      <QueueButton class="action-unlock" @click="emitUnlock" variant="edit">
        {{ $t("actions.unlock") }}
      </QueueButton>
    </div>

    <div class="fixed-wrapper" v-if="order.status == 'editing' && !isDesktop">
      <!-- 1 -->

      <QueueButton variant="accept" class="add-dish" @click="showAddDishUI"
        >+ {{ $t("actions.add_dish") }}</QueueButton
      >
      <QueueButton class="confirm p-0" @click="emitFinishEdit">
        <img src="../../assets/ok.svg" />
      </QueueButton>

      <!-- <div class="order-actions-box mt-10 w-100">
       <QueueButton class="action-cancel-button special mr-0" variant="cancel">
        <img src="/icons/back2.svg" class="del" />
      </QueueButton>
      <small class="info">Оберіть страву</small>
      </div>-->

      <!--3 <div class="order-actions-box w-100">
      <QueueButton class="action-cancel-button" variant="cancel">
        <img src="/icons/back2.svg" class="del" />
      </QueueButton>
      <QueueButton
        @click="emitAccept"
        class="w-100"
        variant="accept"
      >Додати до чеку</QueueButton>
      </div>-->

      <!--4 <div class="order-actions-box w-100">
      <QueueButton class="action-cancel-button" variant="cancel">
        <img src="/icons/back2.svg" class="del" />
      </QueueButton>
      <QueueButton
        @click="emitAccept"
        class="w-100"
        variant="serve"
      >Перейти до чеку</QueueButton>
      </div>-->
    </div>
  </div>
</template>

<script>
import QueueButton from "@/components/QueueButton.vue";

import OrderHelpers from "@/services/order/helpers.js";

import CenteredSelect from "@/components/CenteredSelect.vue";

import PaymentMethods from "@/components/item/PaymentMethods.vue";

import AddDish from "@/components/modals/AddDish.vue";

import Navbar from "@/components/Navbar.vue";

export default {
  props: {
    order: Object,
    hidePayment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //discounts: [0,1,2,3,5,7,10,12,15,20,25,50,100],
      discounts: [],
      pay: {
        discount: 0,
        pay_method: "cash",
      },
      showOptions: false,
      addDishModal: false,
      OrderHelpers,
    };
  },
  watch: {
    "pay.discount"() {
      this.$emit("discountChange", this.pay.discount);
    },
  },
  methods: {
    emitCancel() {
      this.$emit("cancel");
    },
    emitAccept() {
      this.$emit("accept");
    },
    emitServe() {
      this.$emit("serve");
    },
    emitEdit() {
      this.$emit("edit");
    },
    emitPay() {
      this.$emit("pay");
    },
    emitConfirmPay() {
      this.$emit("confirmPay", this.pay);
    },
    emitChangeTable() {
      this.$emit("changeTable");
    },
    emitMerge() {
      this.$emit("merge");
    },
    emitSplit() {
      this.$emit("split");
    },
    emitUnlock() {
      this.pay.pay_method = "cash";
      this.$emit("unlock");
    },
    emitReturn() {
      this.$emit("return");
    },
    toggleOptions() {
      this.showOptions = !this.showOptions;
    },
    emitFinishEdit() {
      this.$emit("finishEdit");
      this.showOptions = false;
    },
    showAddDishUI() {
      this.$emit("showAddDishUI");
    },
  },
  mounted() {
    if (this.order.pay_method) {
      this.pay.pay_method = this.order.pay_method;
    }

    for (let i = 0; i <= 105; i += 5) this.discounts.push(i);
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    currency() {
      return this.$store.state.currency;
    },
    cafe() {
      return this.$store.state.cafe;
    },
  },
  components: {
    QueueButton,
    CenteredSelect,
    PaymentMethods,
    AddDish,
    Navbar,
  },
};
</script>

<style scoped>
.actions-status-waiting {
  display: flex;
  justify-content: space-between;
  margin: 2.5vh 5.4vw 0;
}

.order-actions-box .w-100 {
  padding: 1.5vh;
}

.mt-10 {
  margin-top: 1.8vh !important;
}

.action-cancel-button.special {
  width: 6.2vh;
}

small.info {
  padding-top: 2vh;
}

.fixed-wrapper {
  position: fixed;
  background: #1d1d1b;
  padding: 1.3vh 3.2vh 2.6vh;
  display: flex;
  justify-content: space-between;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
}

.actions-cheque {
  display: flex;
  justify-content: space-between;
  margin-top: 2.1vh;
  padding: 0 5.4vw;
  width: 100%;
}

img.cancel {
  vertical-align: text-top;
  margin: 0 auto;
  display: block;
}

.confirm {
  /* background: #416293; */
  background: #1d1d1b;
  color: #ededed;
}

.confirm img {
  width: 6vh;
  height: 6vh;
}

.w-100 {
  width: 100%;
}

.add-dish {
  background: transparent;
  border: 1px solid #129b81;
  padding: 1.5vh;
  width: 100%;
  margin-right: 2vh;
}
.pt-15 {
  padding-top: 1.9vh !important;
}

.actions-status-waiting img {
  height: 2.5vh;
  width: auto;
}

.form-group {
  text-align-last: center;
  margin: 1.9vh auto 0;
  background: #ededed;
  box-shadow: 0px 1px 7px #dadada;
  border: none;
  font-weight: bold;
  color: #5a5a5a;
  border-radius: 5vh;
}

.form-control {
  height: auto;
}

.btn-options {
  width: 90vw;
  margin: 0 auto;
  display: block;
  box-shadow: none !important;
  border-radius: 50px;
  background: transparent;
  border: 1px solid #303030;
  color: #303030;
}

.serving-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

img.arrow1 {
  margin-top: -0.5vh;
  margin-left: 0.8vw;
  width: auto;
  transition: 0.3s;
  height: 2vh;
  transform: rotate(90deg);
}

img.arrow2 {
  margin-top: -0.5vh;
  width: auto;
  margin-left: 1.5vw;
  margin-right: 1vw;
  height: 2vh;
  transition: 0.3s;
  transform: rotate(270deg);
}

h5.modif {
  text-align: right;
  font-weight: 500;
  font-size: 2.3vh;
  margin: 0;
  padding: 0 !important;
  cursor: pointer;
}

.option-icon {
  margin: 5px -25px 0 10px;
  float: left;
}

.overall {
  padding: 0 5.4vw;
  margin-top: 3.7vh;
}

.overall h4 {
  width: 35vw;
  display: inline-block;
  padding-top: 0.4vh;
}

.total {
  font-weight: bold;
  display: inline-block;
  margin: 0 !important;
  font-size: 6.5vw;
  text-align: initial;
  padding-top: 0.9vh;
  line-height: 0.8;
}

span.amount {
  float: right;
  margin-top: 0vh;
  line-height: 0.8;
  font-size: 9.6vw;
  font-weight: 500;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}

.img-trash {
  height: 2.9vh !important;
}

.btn-cancel {
  background: #e2223b;
  height: 6.2vh;
  width: 6.2vh;
  padding: 0 !important;
}

.actions-status-serving {
  padding: 2.5vh 5.4vw 0.5vh;
}

.serving-actions {
  display: flex;
  justify-content: space-between;
  margin: 3.7vh 5.4vw 0;
}

.serving-actions img {
  height: 2.5vh;
  width: auto;
}

.actions-status-served {
  margin: 10px 5px;
  text-align: center;
}

.actions-status-editing {
  display: flex;
  justify-content: space-between;
  margin: 25px 20px;
}

.action-unlock {
  width: 90%;
  margin-top: 10px;
}

.actions-status-liqpay {
  margin: 25px 20px;
  text-align: center;
}

.w-40 {
  width: 38vw !important;
}

.action-edit {
  box-shadow: none;
  width: 100%;
  font-size: 4.3vw;
  background: #ededed;
  border-radius: 5vh;
  display: block;
  margin: 2.7vh auto 0;
  padding: 1.5vh;
}

.action-merge,
.action-split {
  box-shadow: none;
  width: 100%;
  font-size: 4.3vw;
  background: #ededed;
  border-radius: 5vh;
  padding: 1.5vh;
  display: block;
}

.action-return {
  width: 100%;
  box-shadow: none;
  display: block;
  border: 1px solid rgb(255, 73, 41);
  color: #fd0b0b;
  margin: 15px auto;
}

.discount b,
.choose-pay b {
  font-weight: 400;
  line-height: 0.8;
  font-size: 5vw;
}

/*
TODO: make responsive and good-looking serve button.
*/
.action-serve {
  margin-top: 2.5vh;
}

p {
  color: #303030;
}

.method-cash,
.method-card {
  width: 20px;
  height: 20px;
  position: relative;
  top: 5px;
}

.choose-pay label {
  font-weight: 500;
  font-size: 18px;
}

.action-confirmPay {
  display: block;
  width: 60vw;
  font-weight: 500;
}

.discount {
  padding: 2.5vh 5.4vw 0;
}

.discount-combobox {
  text-align-last: center;
  text-align: -webkit-center;
  background: #ededed;
  border: 1px solid #a4a3a1;
  font-size: 3vh;
  font-weight: bold;
  padding: 0.8vh 0 0.7vh;
  color: #5a5a5a;
  border-radius: 5vh;
}
@media (min-width: 768px) {
  .actions-status-waiting {
    margin: 0 1.389vw;
  }
  img.button-img {
    width: 1.389vw;
    height: 1.389vw;
  }
  .actions-status-serving {
    padding: 1.389vw;
  }
  .action-serve {
    margin-top: 1.389vw;
  }
  h5.modif {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .discount {
    padding: 1.389vw 1.389vw;
  }
  .discount b {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .form-control.discount-combobox {
    width: 100%;
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .choose-pay {
    padding: 0 1.389vw;
  }
  .choose-pay b {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .pay-option {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .overall {
    padding: 0 1.389vw;
    margin-top: 1.389vw;
  }
  h4.mb-0 {
    font-size: 1.667vw;
    line-height: 1.944vw;
    width: auto;
  }
  span.amount {
    font-size: 2.5vw;
    line-height: 2.847vw;
  }
  .actions-cheque {
    padding: 0 1.389vw;
    margin-top: 1.389vw;
  }
  .serving-actions {
    padding: 0 1.389vw;
    margin: 1.389vw 0 0;
  }
  div.pay-option {
    width: 9.583vw;
    height: 3.264vw;
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  div.pay-option.active {
    padding: 0;
  }
  button.action-merge.queue-button,
  button.action-split.queue-button {
    width: 9.653vw !important;
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .serving-wrapper button.action-serve.variant-serve {
    margin: 0;
  }
  .serving-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.389vw;
  }
  div.actions-status-serving {
    padding: 0.694vw 1.389vw 1.389vw;
  }
  div.actions-status-serving.pt-20 {
    padding-top: 0 !important;
    padding-bottom: 0;
  }
  div.order-actions-box {
    margin: 0 !important;
    padding-top: 1.389vw;
    display: flex;
    justify-content: space-between;
  }
  div.order-actions-box#special {
    margin: 0 1.389vw 0 !important;
  }
  .w-100.queue-button.variant-accept.action-pay {
    /* width: 20.486vw !important; */
    width: 100% !important;
  }
  .w-100.action-confirmPay.queue-button.variant-dark {
    width: 80% !important;
  }
  .w-100.queue-button.variant-accept {
    width: 80% !important;
  }
  button.action-edit {
    margin-top: 0.694vw;
  }
  img.arrow1,
  img.arrow2 {
    width: 0.764vw;
    height: 1.25vw;
    margin: 0 0 0 1.181vw;
  }
}
</style>
